import list from './list';
import upsert from './upsert';

export default {
  namespaced: true,
  modules: {
    list,
    upsert,
  },
};
